// MUZI BATTLE - Mock Data

export const COLORS = {
  primary: '#FF006E',
  secondary: '#8338EC',
  accent: '#3A86FF',
  yellow: '#FFBE0B',
  green: '#06D6A0',
  dark: '#0A0A0F',
  card: '#15151F',
};

export const AVATARS_PRESET = [
  { id: 'av1', name: 'Néon Star', emoji: '✨', img: 'https://images.unsplash.com/photo-1740252117012-bb53ad05e370?w=400', style: 'cartoon', locked: false },
  { id: 'av2', name: 'Cyber Diva', emoji: '🤖', img: 'https://images.unsplash.com/photo-1535119512-9e6a24a532c7?w=400', style: 'cartoon', locked: false },
  { id: 'av3', name: 'Rock Anime', emoji: '🎸', img: 'https://images.unsplash.com/photo-1559011192-0e97c6558662?w=400', style: 'anime', locked: false },
  { id: 'av4', name: 'Pop Star', emoji: '🌟', img: 'https://images.pexels.com/photos/8107821/pexels-photo-8107821.jpeg?w=400', style: 'real', locked: true, price: 4.99 },
  { id: 'av5', name: 'Hip-Hop Legend', emoji: '🔥', img: 'https://images.pexels.com/photos/8041083/pexels-photo-8041083.jpeg?w=400', style: 'real', locked: true, price: 4.99 },
  { id: 'av6', name: 'Galaxy Hero', emoji: '🚀', img: 'https://images.pexels.com/photos/29848655/pexels-photo-29848655.jpeg?w=400', style: 'cartoon', locked: true, price: 9.99 },
];

export const FILTERS = [
  { id: 'f1', name: 'Aucun', icon: '⚪', locked: false },
  { id: 'f2', name: 'Néon', icon: '💜', locked: false },
  { id: 'f3', name: 'Cartoon', icon: '🎨', locked: false },
  { id: 'f4', name: 'Pixel', icon: '👾', locked: false },
  { id: 'f5', name: 'Anime', icon: '🌸', locked: false, premium: true, price: 1.99 },
  { id: 'f6', name: 'Cyberpunk', icon: '🤖', locked: false, premium: true, price: 2.99 },
  { id: 'f7', name: 'Hologram', icon: '🔮', locked: false, premium: true, price: 2.99 },
  { id: 'f8', name: 'Vintage', icon: '📺', locked: false, premium: true, price: 1.99 },
];

export const BACKGROUNDS = [
  { id: 'bg1', name: 'Scène Néon', img: 'https://images.unsplash.com/photo-1559011192-0e97c6558662?w=600', price: 0 },
  { id: 'bg2', name: 'Studio Pro', img: 'https://images.pexels.com/photos/8041083/pexels-photo-8041083.jpeg?w=600', price: 0 },
  { id: 'bg3', name: 'Foule Concert', img: 'https://images.unsplash.com/photo-1535119512-9e6a24a532c7?w=600', price: 1.99 },
  { id: 'bg4', name: 'Cyberpunk City', img: 'https://images.pexels.com/photos/29848655/pexels-photo-29848655.jpeg?w=600', price: 2.99 },
  { id: 'bg5', name: 'Galaxie', img: 'https://images.pexels.com/photos/8107821/pexels-photo-8107821.jpeg?w=600', price: 2.99 },
];

export const COACHES = [
  { id: 'c1', name: 'MAX', emoji: '😎', desc: 'Le Pote Cool', phrases: ['Yo c\'est feu !', 'Vas-y t\'es prêt(e) !', 'GROSSE perf !', 'Refais-le mais en mode FEU 🔥'] },
  { id: 'c2', name: 'LUNA', emoji: '💫', desc: 'La Diva', phrases: ['Magnifiqueeee chérie !', 'Plus de power !', 'Tu es une star ⭐', 'Encore plus aigu !'] },
  { id: 'c3', name: 'BOOM', emoji: '🎤', desc: 'Le Rappeur', phrases: ['Yeah yeah yeah !', 'C\'est du SALE !', 'Bars de OUF !', 'Drop it like it\'s hot 🔥'] },
  { id: 'c4', name: 'ZEN', emoji: '🧘', desc: 'Le Mentor', phrases: ['Respire et lâche tout', 'Crois en toi', 'Belle énergie', 'L\'art te transcende'] },
  { id: 'c5', name: 'SPARK', emoji: '⚡', desc: 'L\'Énergique', phrases: ['LET\'S GOOO !', 'BOOM BOOM !', 'EXPLOSE TOUT !', 'Énergie au MAX !'] },
  { id: 'c6', name: 'KIKI', emoji: '🦋', desc: 'L\'Original', phrases: ['Wahou trop stylé', 'Tu créés ta vibe', 'C\'est UNIQUE !', 'Ça c\'est de l\'art'] },
];

export const BATTLE_CARDS_VOCAL = [
  { id: 'bv1', word: 'AMOUR', category: 'PASSION', emoji: '❤️', color: '#FF006E', hint: 'Chante un mot ou une phrase liée à l\'amour' },
  { id: 'bv2', word: 'DANSE', category: 'MOUVEMENT', emoji: '💃', color: '#8338EC', hint: 'Chante avec du rythme et de l\'énergie' },
  { id: 'bv3', word: 'NUIT', category: 'AMBIANCE', emoji: '🌙', color: '#3A86FF', hint: 'Chante sur le thème de la nuit' },
  { id: 'bv4', word: 'SOLEIL', category: 'NATURE', emoji: '☀️', color: '#FFBE0B', hint: 'Une chanson qui parle du soleil' },
  { id: 'bv5', word: 'LIBRE', category: 'ÉMOTION', emoji: '🕊️', color: '#06D6A0', hint: 'Sur la liberté' },
  { id: 'bv6', word: 'PARTY', category: 'FÊTE', emoji: '🎉', color: '#FF006E', hint: 'Une chanson de fête' },
  { id: 'bv7', word: 'CŒUR', category: 'ÉMOTION', emoji: '💖', color: '#8338EC', hint: 'Quelque chose qui parle du cœur' },
  { id: 'bv8', word: 'FEU', category: 'INTENSITÉ', emoji: '🔥', color: '#FF006E', hint: 'Avec puissance et intensité' },
];

export const BATTLE_CARDS_SILENCE = [
  { id: 'bs1', type: 'VERBE', target: 'D-O-S', emoji: '🏃', color: '#8338EC', examples: ['DOSER', 'ADOSSER', 'REDOSSER'], hint: 'Verbe contenant les lettres D-O-S' },
  { id: 'bs2', type: 'JEUX', target: 'F-O-R', emoji: '🎮', color: '#3A86FF', examples: ['FORTNITE', 'FORZA', 'FORMULA'], hint: 'Nom de jeu avec F-O-R' },
  { id: 'bs3', type: 'CUISINE', target: 'P-A-S', emoji: '🍳', color: '#06D6A0', examples: ['PASTA', 'PASTÈQUE', 'PASTIS'], hint: 'Aliment avec P-A-S' },
  { id: 'bs4', type: 'SPORT', target: 'B-A-L', emoji: '⚽', color: '#FFBE0B', examples: ['BALLE', 'BALLON', 'BASEBALL'], hint: 'Mot de sport avec B-A-L' },
  { id: 'bs5', type: 'PASSION', target: 'A-M-O', emoji: '❤️', color: '#FF006E', examples: ['AMOUR', 'AMOROSO', 'AMORPHE'], hint: 'Lié à la passion avec A-M-O' },
];

export const EFFECT_PACKS = [
  { id: 'p1', name: 'Néon Vibes', emoji: '💜', price: 2.99, count: 12, color: 'from-pink-500 to-purple-600' },
  { id: 'p2', name: 'Anime Pack', emoji: '🌸', price: 3.99, count: 15, color: 'from-pink-400 to-rose-500' },
  { id: 'p3', name: 'Cyber Future', emoji: '🤖', price: 4.99, count: 20, color: 'from-blue-500 to-purple-600' },
  { id: 'p4', name: 'Party Mode', emoji: '🎉', price: 1.99, count: 8, color: 'from-yellow-400 to-pink-500' },
  { id: 'p5', name: 'Halloween', emoji: '🎃', price: 2.99, count: 10, color: 'from-orange-500 to-purple-900' },
  { id: 'p6', name: 'Stars Pack', emoji: '⭐', price: 9.99, count: 30, color: 'from-yellow-500 to-pink-600', popular: true },
];

export const CARD_PACKS = [
  { id: 'cp1', name: 'Pack Classique', emoji: '🎤', price: 0, count: 50, desc: 'Inclus dès le départ' },
  { id: 'cp2', name: 'Pack Stars 2025', emoji: '⭐', price: 4.99, count: 40, desc: 'Cartes spéciales artistes' },
  { id: 'cp3', name: 'Pack Films', emoji: '🎬', price: 3.99, count: 35, desc: 'Bandes originales cultes' },
  { id: 'cp4', name: 'Pack Animés', emoji: '🌸', price: 3.99, count: 30, desc: 'Génériques animés' },
  { id: 'cp5', name: 'Pack Hip-Hop', emoji: '🎧', price: 4.99, count: 45, desc: 'Punchlines & rap' },
  { id: 'cp6', name: 'Pack Halloween', emoji: '🎃', price: 2.99, count: 20, desc: 'Saisonnier - effrayant' },
];

export const LIVE_TRACKS = [
  { id: 't1', title: 'Démo Track 1', artist: 'MUZI Originals', cover: 'https://images.unsplash.com/photo-1559011192-0e97c6558662?w=300', duration: '3:24' },
  { id: 't2', title: 'Néon Lights', artist: 'Cyber Vibes', cover: 'https://images.pexels.com/photos/8041083/pexels-photo-8041083.jpeg?w=300', duration: '2:58' },
  { id: 't3', title: 'Galaxy Drop', artist: 'Spark FM', cover: 'https://images.pexels.com/photos/29848655/pexels-photo-29848655.jpeg?w=300', duration: '3:42' },
  { id: 't4', title: 'Cartoon Beat', artist: 'Anime Soul', cover: 'https://images.unsplash.com/photo-1740252117012-bb53ad05e370?w=300', duration: '2:30' },
];

export const TOP_STARS = [
  { id: 'u1', name: 'Léa_Vibes', avatar: '👩‍🎤', fans: 12453, score: 98500, badge: '👑' },
  { id: 'u2', name: 'TheoBoom', avatar: '🎤', fans: 8902, score: 87200, badge: '🥈' },
  { id: 'u3', name: 'NeonGirl', avatar: '💜', fans: 7621, score: 82100, badge: '🥉' },
  { id: 'u4', name: 'KaiPlays', avatar: '🎮', fans: 5430, score: 74500, badge: '🔥' },
  { id: 'u5', name: 'ZoeStar', avatar: '⭐', fans: 4892, score: 69800, badge: '🌟' },
  { id: 'u6', name: 'MaxFlow', avatar: '🎧', fans: 4210, score: 65300, badge: '🎯' },
  { id: 'u7', name: 'IrisVoice', avatar: '🎵', fans: 3987, score: 61200, badge: '💎' },
  { id: 'u8', name: 'JoCyber', avatar: '🤖', fans: 3540, score: 58400, badge: '⚡' },
];

export const USER_PROFILE = {
  id: 'me',
  username: 'Toi_Star',
  avatar: '✨',
  level: 12,
  xp: 2840,
  xpToNext: 3500,
  fans: 248,
  following: 89,
  battlesWon: 34,
  battlesTotal: 52,
  songsCreated: 8,
  totalLikes: 1204,
  coins: 250,
  rank: 1247,
};

export const RECENT_BATTLES = [
  { id: 'rb1', mode: 'Vocal vs IA', opponent: 'MUZI IA', result: 'win', score: '8-5', date: 'Il y a 2h', emoji: '🤖' },
  { id: 'rb2', mode: 'Silence vs Online', opponent: 'TheoBoom', result: 'loss', score: '6-9', date: 'Il y a 5h', emoji: '🎤' },
  { id: 'rb3', mode: 'Vocal vs IA', opponent: 'MUZI IA', result: 'win', score: '10-3', date: 'Hier', emoji: '🤖' },
  { id: 'rb4', mode: 'Karaoké Live', opponent: 'NeonGirl', result: 'win', score: '95%', date: 'Hier', emoji: '🎵' },
  { id: 'rb5', mode: 'Silence vs Online', opponent: 'ZoeStar', result: 'win', score: '12-8', date: 'Avant-hier', emoji: '✍️' },
];

export const NAV_ITEMS = [
  { name: 'Accueil', path: '/', icon: 'Home' },
  { name: 'Studio', path: '/studio', icon: 'Camera' },
  { name: 'Battle', path: '/battle', icon: 'Swords' },
  { name: 'Live', path: '/live', icon: 'Mic' },
  { name: 'Fans', path: '/fans', icon: 'Users' },
  { name: 'Boutique', path: '/shop', icon: 'ShoppingBag' },
];
